<div class="migration-in-progress flex flex-column center gap-30">
  <div class="title center">
    {{ 'Your account is being migrated, this may take a few moments.' | translate }}
  </div>
  <div>
    <mat-spinner mode="indeterminate" diameter="100" color="#4471B8"></mat-spinner>
  </div>
</div>
